import React, { useState, useEffect, useMemo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { all_routes } from '../router/all_routes';
import { AppDispatch } from '../../core/data/redux/store';
import ImageWithBasePath from '../../core/data/img/ImageWithBasePath';
import {
  set_is_mobile_sidebar,
  logout,
  getSettings,
  getProfile,
} from '../../core/data/redux/action';
import { Menu } from 'react-feather';
import { RootState } from '../../core/data/redux/store';
import { useDispatch, useSelector } from 'react-redux';

const Header = () => {
  const routes = all_routes;
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const [isMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    dispatch(set_is_mobile_sidebar(false));
  }, [dispatch]);

  useEffect(() => {
    dispatch(set_is_mobile_sidebar(false));
  }, [location.pathname, dispatch]);

  const { user, mobileSidebar } = useSelector((state: RootState) => ({
    mobileSidebar: state.common.mobileSidebar,
    user: state.auth.user,
  }));
  const sidebarClass = useMemo(
    () => (mobileSidebar ? 'menu-opened' : ''),
    [mobileSidebar]
  );

  useEffect(() => {
    document.documentElement.className = sidebarClass;
  }, [sidebarClass]);

  useEffect(() => {
    dispatch(getSettings());

     if (localStorage.getItem('token')) {
          dispatch(getProfile());
        }

  }, []);

  const handleClick = () => {
    dispatch(set_is_mobile_sidebar(!mobileSidebar));
  };

  const token = localStorage.getItem('token');
  const navigate = useNavigate();

setTimeout(() => {
  const anyModalOpen = document.querySelector('.modal.show');
  const backdrops = document.querySelectorAll('.modal-backdrop');

  if (!anyModalOpen && backdrops.length) {
    // Remove all backdrops and reset body styles if no modal is open
    backdrops.forEach((backdrop) => backdrop.remove());
    document.body.classList.remove('modal-open');
    document.body.style = '';
  } else if (backdrops.length > 1) {
    // Remove extra backdrops, keep only the first one
    backdrops.forEach((backdrop, index) => {
      if (index > 0) backdrop.remove();
    });
  } else if (anyModalOpen && backdrops.length === 0) {
    
    // Re-add backdrop if modal is open but backdrop is missing
    const newBackdrop = document.createElement('div');
    newBackdrop.className = 'modal-backdrop fade show';
    document.body.appendChild(newBackdrop);
    document.body.classList.add('modal-open');
  }
}, 300);


  // const isRestrictedCustomer = localStorage.getItem("isRestrictedCustomer");
  // show: isRestrictedCustomer === ("true" || true) ? false : true,

  // const menuList = [
  //   { text: "Find our cars in Uber", show: true, link: routes.listingGrid, class: "nav-link", icons: "" },
  //   { text: "Search for Cars", show: true, link: routes.listingGrid, class: "nav-link", icons: "" },

  // ];

  const handleSearchSubmit = (e?: React.FormEvent) => {
    if (e) e.preventDefault(); // Prevent form reload
    const searchParams = new URLSearchParams({
      // pickupDate: dayjs().format("YYYY-MM-DD"),
      // pickupTime: ,
      // returnDate: dayjs().format("YYYY-MM-DD"),
      // returnTime: ,
    });

    navigate(`${all_routes.listingGrid}?${searchParams.toString()}`);
  };

  const menuList = [
    {
      text: 'Search for cars',
      show: true,
      link: routes.listingGrid,
      class: 'nav-link',
      icons: '',
    },
    // { text: "How it works", show: true, link: routes.howItWorks, class: "nav-link" },
    { text: 'Pricing', show: true, link: routes.pricing, class: 'nav-link' },
    // { text: "Why us?", show: true, link: routes.whyUs, class: "nav-link" },

    ...(user?.id || token
      ? [
          {
            text: 'User',
            link: '#',
            show: true,
            class: 'nav-link  ',
            icons: <i className="fas fa-chevron-down" />,

            subMenu: [
              //   {
              //   text: "Dashboard", link: routes.userDashboard, class: " ", icons: "",
              // },
              {
                text: 'My Bookings',
                link: routes.userBookings,
                class: '  ',
                icons: '',
              },
              {
                text: 'My Payments',
                link: routes.userPayment,
                class: ' ',
                icons: '',
              },
              {
                text: 'Settings',
                link: routes.userSettings,
                class: ' ',
                icons: '',
              },
            ],
          },
        ]
      : []),
  ];

  const userMenu = [
    ...(user?.id || token
      ? [
          {
            text: 'Log Out',
            show: true,
            link: routes.login,
            class: 'fw-bold header-login px-3',
            icons: <i className="fa-regular fa-user" />,
            onClick: () => {
              dispatch(logout());
              navigate('/login');
              localStorage.removeItem('token');
              // localStorage.removeItem("isRestrictedCustomer");
              window.location.reload();
            },
          },
        ]
      : [
          {
            text: 'Sign In',
            class: 'py-2 px-3  px-md-4 header-login',
            show: true,
            link: routes.login,
            icons: <i className="fa-regular fa-user" />,
          },
          {
            text: 'Sign Up',
            class: 'py-2  px-3  px-md-4 header-reg',
            show: true,
            link: routes.register,
            icons: <i className="fa-solid fa-lock" />,
          },
        ]),
  ];

  // const [showList, setShowList] = useState(false);
  // const dropdownRef = useRef(null);

  // const notifications = [
  //   { 'id': 1, message: 'New message from John', },
  //   { 'id': 2, message: 'Task completed: Report Review', },
  //   { 'id': 3, message: 'Server backup successful', },
  // ];

  // const toggleList = () => {
  //   setShowList(!showList);
  // };

  // // Close dropdown when clicking outside
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setShowList(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);

  return (
    <>
      <header className="header border-0">
        <div className="container-fluid ">
          <nav className="navbar navbar-expand-lg header-nav">
            <div className="navbar-header">
              <Link
                to={routes.homeOne}
                className="navbar-brand logo text-start"
              >
                <ImageWithBasePath
                  src="assets/img/logo/fairRentallogo.png"
                  className="img-fluid logo-style"
                  alt="Logo"
                />
              </Link>

              <div className={'navbar-brand logo-small text-start'}>
                <Link to={routes.homeOne} className={'navbar-brand'}>
                  <ImageWithBasePath
                    src="assets/img/logo/fairRentallogo-small.png"
                    className="img-fluid logo-style"
                    alt="Logo"
                  />
                </Link>
              </div>

              <div className="d-flex align-items-center">
                {/* <div className="position-relative inline-block text-left me-5 d-md-none" ref={dropdownRef}>

                  <i
                    className="fa fa-bell fs-5  cursor-pointer"
                    onClick={toggleList}
                  // style={{ fontSize: '20px', cursor: 'pointer', color: '#333' }}
                  ></i>

                  {showList && (
                    <div className="position-absolute end-50 mt-2 bg-white shadow-lg rounded-lg border z-50" style={{
                      width: "170px"
                    }}>

                      <ul className="  ">
                        <li className="float-end visible  px-2 fs-5">  × </li>

 
                        {notifications?.length > 0 ? (
                          notifications?.map((note, index) => (
                            <li key={index} className="px-4 py-2 hover:bg-gray-100 text-sm">
                              {note?.message}
                            </li>
                          ))
                        ) : (
                          <li className="px-4 py-2 text-sm text-gray-500">No notifications</li>
                        )}
                      </ul>
                    </div>
                  )}
                </div> */}

                <div className="d-flex ">
                  <Link
                    id=""
                    to="#"
                    className="d-md-none"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(routes.userBookings);
                    }}
                  >
                    <ImageWithBasePath
                      src="assets/img/home/user.svg"
                      // className="img-fluid logo-style"
                      alt="Logo"
                    />
                  </Link>

                  <Link
                    id="mobile_btn"
                    to="#"
                    className="position-relative"
                    onClick={(e) => {
                      e.preventDefault();
                      handleClick();
                    }}
                  >
                    <Menu />
                  </Link>
                </div>
              </div>

              {/* {open && (
                <div
                  ref={popoverRef}
                  style={{
                    position: "absolute",
                    top: "70%",
                    right: "0",
                    width: "150px",
                    background: "#fff",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
                    borderRadius: "8px",
                    padding: "12px 0",
                    zIndex: 100,
                  }}
                >


                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {menuList?.map((item, index) => (
                      <li
                        key={index}
                        onClick={() => setOpen(false)}
                        style={{
                          // padding: "10px 16px",
                          cursor: "pointer",
                          fontSize: "12px",
                          //  fontWeight: "500",
                          transition: "background 0.2s ease-in-out",
                        }}
                      >
                        <a
                          href={item.link}
                          style={{
                            textDecoration: "none",
                            color: "#333",
                            display: "block",
                            width: "100%",
                            padding: "10px 10px",
                          }}
                        >
                          {item.text}
                        </a>
                      </li>
                    ))}
                  </ul>

                </div>
              )} */}
            </div>
            <div className="main-menu-wrapper mx-0">
              <div className="menu-header">
                <Link to={routes.homeOne} className="menu-logo">
                  <ImageWithBasePath
                    src="assets/img/logo/fairRentallogo.png"
                    className="img-fluid"
                    alt="Logo"
                  />
                </Link>
                <Link
                  id="menu_close"
                  className="text-primary-dark"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault(); // Prevents navigation
                    handleClick(); // Executes your custom logic
                  }}
                >
                  {' '}
                  <i className="fas fa-times fs-5" />
                </Link>
              </div>

              <ul
                className={` align-items-center  main-nav  ${isMobile ? '' : 'nav header-navbar-rht'}`}
                style={{
                  height: '80px',
                }}
              >
                {menuList
                  ?.filter((item) => item.show === true)
                  ?.map((item, index) => (
                    <li
                      key={index}
                      className={`nav-item mx-0 w-100 d-md-none  ${item?.icons && !item?.subMenu ? 'py-2' : ''}  ${item?.subMenu ? 'has-submenu' : ''}   ${location.pathname.includes('listing') ? 'active' : ''}`}
                      onClick={item?.onClick}
                    >
                      <Link
                        to={item.link}
                        className={item?.class}
                        onClick={() => {
                          handleClick();
                        }}
                      >
                        {!item?.subMenu && <span> {item?.icons} </span>}{' '}
                        {item.text}{' '}
                        {item?.subMenu && <span> {item?.icons} </span>}{' '}
                      </Link>

                      {item?.subMenu && (
                        <ul className="submenu d-block">
                          {item?.subMenu?.map((subItem, index) => (
                            <li key={index}>
                              <Link
                                to={subItem.link}
                                className={subItem?.class}
                                onClick={() => {
                                  handleClick();
                                }}
                              >
                                {subItem.text}{' '}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}

                {/* {token && <li className="align-content-center nav-item mx-0  py-2 d-none d-md-flex">
                  <div className="position-relative inline-block text-left" ref={dropdownRef}>
                    <i className="fa fa-bell fs-5  cursor-pointer"
                      onMouseEnter={toggleList}
                      onClick={toggleList}
                    ></i>

                    {showList && (
                      <div className="position-absolute end-50 mt-2 bg-white shadow-lg rounded-lg border z-50">

                        <ul className="position-static opacity-100 visible ">
                          <li className="float-end visible  px-2 fs-5">  × </li>
                          {notifications?.length > 0 ? (
                            notifications?.map((note, index) => (
                              <li key={index} className="visible px-4 py-2 hover:bg-gray-100 text-sm">
                                {note?.message}
                              </li>
                            ))

                          ) : (
                            <li className="visible  px-4 py-2 text-sm text-gray-500">No notifications</li>
                          )} 

                          <li className="visible px-4 py-2 hover:bg-gray-100 text-sm "> View All Notifications </li>

                        </ul>
                      </div>
                    )}
                  </div>

                </li>} */}

                <li className="nav-item mx-0  py-2 d-none d-md-block">
                  <Link
                    id=""
                    to="#"
                    className=""
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(routes.userBookings);
                    }}
                  >
                    <ImageWithBasePath
                      src="assets/img/home/user.svg"
                      // className="img-fluid logo-style"
                      alt="Logo"
                    />
                  </Link>
                </li>

                <li className="nav-item mx-0  py-2 d-none d-md-block">
                  <Link
                    to="https://bonjour.uber.com/marketplace/marketplaces/vehicles_us/earnings_share/product/aea42e6b-b85a-5dbe-8991-8ae8f99dec71/offer/cc7af0f5-89ca-58f8-abc7-751d4e4eaab7"
                    target="_blank"
                    className="btn fs-15   text-black  py-2   px-4 "
                    style={{
                      background: '#E4F6FC',
                      padding: isMobile ? '' : '10px  0px 11px 0px',
                    }}
                  >
                    Find our cars in Uber{' '}
                  </Link>
                </li>
                <li className="nav-item mx-0  py-2  d-none d-md-block">
                  {' '}
                  <button
                    className="btn  fs-15 text-white   py-2 px-4 "
                    onClick={() => {
                      handleSearchSubmit();
                    }}
                    style={{
                      background: 'linear-gradient(#00B6F0, #9AE6FD)',
                      padding: isMobile ? '' : '10px  0px 11px 0px',
                    }}
                  >
                    {' '}
                    Search for Cars{' '}
                  </button>
                </li>

                {userMenu
                  ?.filter((item) => item.show === true)
                  ?.map((item, index) => (
                    <li
                      key={index}
                      className={`nav-item mx-0 mx-0 py-2 
                      ${item?.icons && !item?.subMenu ? 'py-2' : ''}    ${item?.subMenu ? 'has-submenu' : ''}  ${isMobile ? ' w-100' : ''} 
                       ${location.pathname.includes('listing') ? 'active' : ''}`}
                      onClick={item.onClick}
                    >
                      <Link
                        to={item.link}
                        className={item?.class}
                        onClick={() => {
                          handleClick();
                        }}
                        style={{
                          padding: isMobile ? '' : '10px  0px 11px 0px',
                        }}
                      >
                        {/* * {!item?.subMenu && <span>  {item?.icons} </span>} *  */}
                        {item.text}
                        {/* {item?.subMenu && <span>  {item?.icons} </span>  }   *  */}
                      </Link>

                      {item?.subMenu && (
                        <ul className="submenu d-block">
                          {item?.subMenu?.map((subItem: any, index: string) => (
                            <li key={index}>
                              <Link
                                to={subItem.link}
                                className={subItem?.class}
                                onClick={() => {
                                  handleClick();
                                }}
                              >
                                {subItem.text}{' '}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
              </ul>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
